"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFilterConfig = void 0;
var _ = __importStar(require("lodash"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var config_1 = require("../../config/config");
var Filter_1 = require("./Filter");
var FilterConfig_1 = require("./FilterConfig");
var FilterListItem_1 = __importDefault(require("./FilterListItem"));
var filterConfig = new FilterConfig_1.FilterConfig(31, 31, 3);
var updateFilterConfig = function (newFilterConfig) {
    filterConfig = new FilterConfig_1.FilterConfig(newFilterConfig.NEW_GAME_PERIOD, newFilterConfig.UPCOMING_GAME_PERIOD, newFilterConfig.NUM_RELATED_GAMES);
};
exports.updateFilterConfig = updateFilterConfig;
var FilterList = /** @class */ (function (_super) {
    __extends(FilterList, _super);
    function FilterList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getOrdered = function () { return _this.sort(function (x, y) { return (x.order > y.order ? 1 : -1); }); };
        _this.updateFilter = function (filter, filterListItem) {
            var itemToReplace = filterListItem.selectionType === 'multi_select' ? filterListItem : _this.clearFiltersFromItem(filterListItem);
            var newFilterListItem = new FilterListItem_1.default(itemToReplace.type, itemToReplace.order, itemToReplace.header, itemToReplace.name, itemToReplace.value, itemToReplace.selectionType, __spreadArrays(itemToReplace.filter(function (x) { return x.order !== filter.order && x.name !== filter.name; }), [filter]));
            return FilterList.fromArray(__spreadArrays(_this.filter(function (x) { return x.order !== newFilterListItem.order && x.name !== newFilterListItem.name; }), [
                newFilterListItem
            ]));
        };
        _this.clearFiltersFromItem = function (filterListItem) {
            return new FilterListItem_1.default(filterListItem.type, filterListItem.order, filterListItem.header, filterListItem.name, filterListItem.value, filterListItem.selectionType, __spreadArrays(filterListItem).map(function (filter) { return new Filter_1.Filter(__assign(__assign({}, filter), { isSelected: false })); }));
        };
        _this.clearFilters = function () { return FilterList.fromArray(_this.map(function (x) { return _this.clearFiltersFromItem(x); })); };
        _this.addGameRetailerPrices = function (gameRetailerPrices) {
            var filters = gameRetailerPrices.map(function (x) {
                return new Filter_1.Filter({
                    name: "$" + x,
                    value: x,
                    isSelected: false,
                    order: x
                });
            });
            var newFilterListItem = new FilterListItem_1.default('price', -1, 'Ticket Price', 'Ticket Price', 'retailPrice', 'multi_select', filters);
            return FilterList.fromArray(__spreadArrays(_this, [newFilterListItem]));
        };
        _this.addGameType = function (gameTypes) {
            var filters = gameTypes.map(function (x) {
                return new Filter_1.Filter({
                    name: x.name,
                    value: x.id,
                    isSelected: false,
                    order: x.id
                });
            });
            var newFilterListItem = new FilterListItem_1.default('type', 0, 'Game Type', 'Game Type', 'gameTypeId', 'multi_select', filters);
            return FilterList.fromArray(__spreadArrays(_this, [newFilterListItem]));
        };
        _this.addGameTags = function (gameTagTypes, gameTags) {
            var list = gameTagTypes.map(function (gameTagType) {
                var filters = gameTags
                    .filter(function (x) { return x.gameTagTypeId === gameTagType.id; })
                    .map(function (x) {
                    return new Filter_1.Filter({
                        name: x.name,
                        value: x.id,
                        isSelected: false,
                        order: x.id
                    });
                });
                return new FilterListItem_1.default('tag', gameTagType.id, gameTagType.name, gameTagType.name, "query" + gameTagType.name
                    .split(' ')
                    .map(function (x) { return _.startCase(x.toLowerCase()); })
                    .join(''), 'multi_select', filters);
            });
            return FilterList.fromArray(__spreadArrays(_this, list));
        };
        _this.buildFilterQuery = function () {
            var query = __spreadArrays(_this.filter(function (x) { return x.type === 'tag' && x.filter(function (y) { return y.isSelected; }).length > 0; }).map(function (x) {
                return x.value + "=" + x
                    .filter(function (y) { return y.isSelected; })
                    .map(function (y) { return y.value; })
                    .join(',');
            }), _this.filter(function (x) { return x.type === 'type' && x.filter(function (y) { return y.isSelected; }).length > 0; }).map(function (x) {
                return x.value + ".in=" + x
                    .filter(function (y) { return y.isSelected; })
                    .map(function (y) { return y.value; })
                    .join(',');
            }), _this.filter(function (x) { return x.type === 'date' && x.filter(function (y) { return y.isSelected; }).length > 0; }).map(function (x) {
                return x
                    .filter(function (y) { return y.isSelected; })
                    .map(function (y) { return _this.handleFilter(y); })
                    .join('&');
            }), _this.filter(function (x) { return x.type === 'topprize' && x.filter(function (y) { return y.isSelected; }).length > 0; }).map(function (x) {
                return x.value + "=" + x
                    .filter(function (y) { return y.isSelected; })
                    .map(function (y) { return y.value; })
                    .join(',');
            }), _this.filter(function (x) { return x.type === 'price' && x.filter(function (y) { return y.isSelected; }).length > 0; }).map(function (x) {
                return x.value + ".in=" + x
                    .filter(function (y) { return y.isSelected; })
                    .map(function (y) { return y.value; })
                    .join(',');
            })).join('&');
            return query;
        };
        _this.handleFilter = function (filter) {
            var now = moment_timezone_1.default();
            var query;
            switch (filter.dateFilterType) {
                default:
                case 'new':
                    var period = moment_timezone_1.default().subtract(filterConfig.NEW_GAME_PERIOD, 'days');
                    query = "playBegin.greaterOrEqualThan=" + period.toISOString();
                    break;
                case 'active':
                    query = "playBegin.lessOrEqualThan=" + now.toISOString() + "&playEnd.greaterOrEqualThan=" + now.toISOString() + "&";
                    break;
                case 'upcoming':
                    var upcomingCutoff = moment_timezone_1.default().add(filterConfig.UPCOMING_GAME_PERIOD, 'days');
                    query = "playBegin.greaterOrEqualThan=" + now.toISOString() + "&playBegin.lessOrEqualThan=" + upcomingCutoff.toISOString() + "&";
                    break;
                case 'endingSoon':
                    var endingCutoff = moment_timezone_1.default().add(filterConfig.UPCOMING_GAME_PERIOD, 'days');
                    query = "playEnd.lessOrEqualThan=" + endingCutoff.toISOString() + "&playEnd.greaterOrEqualThan=" + now.toISOString();
                    break;
                case 'ended':
                    query = "playEnd.lessOrEqualThan=" + now.toISOString() + "&";
                    break;
            }
            return query;
        };
        return _this;
    }
    FilterList.fromArray = function (filters) {
        var filterList = new FilterList();
        filters.forEach(function (filterItem) {
            filterList.push(filterItem);
        });
        return filterList;
    };
    FilterList.fixedFilters = function () {
        var gameStatusFilter = new FilterListItem_1.default('date', -3, 'Game Status', 'Game Status', 'gameStatus', 'single_select', [
            new Filter_1.Filter({
                order: 0,
                isSelected: false,
                name: 'Active',
                dateFilterType: 'active'
            }),
            new Filter_1.Filter({
                order: 1,
                isSelected: false,
                name: 'Ending Soon',
                dateFilterType: 'endingSoon'
            }),
            new Filter_1.Filter({
                order: 2,
                isSelected: false,
                name: 'New!',
                dateFilterType: 'new'
            }),
            new Filter_1.Filter({
                order: 3,
                isSelected: false,
                name: 'Upcoming',
                dateFilterType: 'upcoming'
            }),
            new Filter_1.Filter({
                order: 4,
                isSelected: false,
                name: 'Ended, Claims Only',
                dateFilterType: 'ended'
            })
        ]);
        var gameTypeFilter = new FilterListItem_1.default('type', -4, 'Game Type', 'Game Type', 'gameTypeId', 'single_select', [
            new Filter_1.Filter({
                order: 0,
                isSelected: false,
                name: 'instant',
                value: 'instant'
            }),
            new Filter_1.Filter({
                order: 1,
                isSelected: false,
                name: 'fastplay',
                value: 'fastplay'
            })
        ]);
        var gameTopPrizeFilter = new FilterListItem_1.default('topprize', -2, 'Top Prize', 'Top Prize', 'queryTopPrize', 'multi_select', [
            new Filter_1.Filter({
                order: 0,
                isSelected: false,
                name: '1M+',
                value: 'f1000000'
            }),
            new Filter_1.Filter({
                order: 1,
                isSelected: false,
                name: '$500K+',
                value: 'f500000'
            }),
            new Filter_1.Filter({
                order: 2,
                isSelected: false,
                name: '$250K - $500k',
                value: 'f250000-t500000'
            }),
            new Filter_1.Filter({
                order: 3,
                isSelected: false,
                name: '$100K - $250k',
                value: 'f100000-t250000'
            }),
            new Filter_1.Filter({
                order: 4,
                isSelected: false,
                name: '$50K - $100K',
                value: 'f50000-t100000'
            }),
            new Filter_1.Filter({
                order: 5,
                isSelected: false,
                name: '$5K - $50K',
                value: 'f5000-t50000'
            }),
            new Filter_1.Filter({
                order: 6,
                isSelected: false,
                name: 'Less Than $5K',
                value: 't5000'
            }),
            new Filter_1.Filter({
                order: 7,
                isSelected: false,
                name: 'Other',
                value: 'other'
            })
        ]);
        var filterList = new FilterList();
        if (config_1.react_core_config.internalConfig.showGameTypeFilter) {
            filterList.push(gameTypeFilter);
        }
        filterList.push(gameStatusFilter);
        filterList.push(gameTopPrizeFilter);
        return filterList;
    };
    return FilterList;
}(Array));
exports.default = FilterList;
//# sourceMappingURL=FilterList.js.map